import { FocusNode } from '@please/lrud'
import { Element } from 'react-scroll'
import styled, { css } from 'styled-components'

import PromoAsideBg from '@/assets/bg/promo-aside-bg.png'
import { boxHeight, boxWidth } from '@/constants/tiles'

export const Layout = styled(FocusNode)`
  display: flex;
  flex-direction: row;
  margin: 2px auto 0;
  padding-right: 112px;
`
export const LayoutGrid = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const BroadcastMainContainer = styled(FocusNode)<{
  $isClassicHome?: boolean
  $isStageHome?: boolean
}>`
  flex: 0 0 ${boxWidth * 2 + 24}px;
  height: ${boxHeight * 2 + 24}px;
  margin-bottom: 0;
  position: relative;
  border-radius: ${({ $isStageHome }) => ($isStageHome ? '0px' : '24px')};
  overflow: hidden;
  &:after {
    position: absolute;
    display: block;
    content: '';
    width: 100%;
    height: 100%;
    border: 0 !important;
    top: 0;
    left: 0;
    box-shadow: inset 0 0 0 4px transparent;
    border-radius: 24px;
    overflow: hidden;
  }
  &.isFocusedLeaf {
    box-shadow: none;
    &:after {
      z-index: 1;
      box-shadow: inset 0 0 0 4px
        ${(props) => props.theme.colors.broadcast.focusedElem.border};
    }
  }

  ${({ $isClassicHome }) =>
    $isClassicHome &&
    css`
      flex: 0 0 1070px;
      height: 602px;
      margin-bottom: 70px;
    `}

  ${({ $isStageHome }) =>
    $isStageHome &&
    css`
      display: block;
      width: 100%;
      height: 100%;
    `}
`
export const PlaceholderWrapper = styled(FocusNode)`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.broadcast.background};
  & > img {
    max-width: 50%;
    height: 50%;
    object-fit: contain;
    opacity: 0.4;
  }
`

export const BroadcastMainElem = styled.div<{
  $isFullscreen?: boolean
}>`
  height: 100%;
  object-fit: cover;
  background-color: ${(props) => props.theme.colors.broadcast.background};

  & video {
    object-fit: cover;
  }

  ${({ $isFullscreen }) =>
    $isFullscreen &&
    css`
      position: fixed;
      z-index: 12;
      background-color: #000;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
    `}
`
export const ElementItem = styled(Element)`
  margin: 8px 0 8px 16px;
  &:first-of-type {
    margin-top: 0;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
`

export const BroadcastAsideElem = styled(FocusNode)<{
  $isClassicHome?: boolean
}>`
  width: calc(${boxWidth}px + 16px);
  position: absolute;
  top: 0;
  right: 0;
  height: ${boxHeight * 2 + 24}px;
  /* background-image: url(\"${PromoAsideBg}\"); */
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 100% 100%;
  border-radius: 24px;
  ${({ $isClassicHome }) =>
    $isClassicHome &&
    css`
      flex: 1;
      width: calc(500px + 16px);
      position: relative;
      height: 602px;
    `}

  & > div {
    width: calc(100% + 16px);
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 8px;
  }
  &:after {
    content: '';
    width: 8px;
    height: 100%;
    position: absolute;
    right: -16px;
    top: 0;
    z-index: 1;
  }

  & ::-webkit-scrollbar {
    width: 8px;
    background: rgba(255, 255, 255, 0.1);
  }

  & ::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
  }

  & ::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.title};
  }
  ${ElementItem} {
    width: ${({ $isClassicHome }) =>
      $isClassicHome ? '492px' : `${boxWidth}px`};
  }
`
export const ChannelItemElem = styled(FocusNode)`
  background-color: ${(props) =>
    props.theme.colors.broadcast.channelBackground};
  font-size: 24px;
  line-height: 1.3;
  display: flex;
  position: relative;
  height: 108px;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: inset 0 0 0 4px transparent;
  &.isFocusedLeaf {
    z-index: 10;
    background-color: ${(props) =>
      props.theme.colors.broadcast.focusedElem.background};
    box-shadow: inset 0 0 0 4px
      ${(props) => props.theme.colors.broadcast.focusedElem.border};
  }
  &.isChannelActive {
    background-color: ${(props) =>
      props.theme.colors.broadcast.activeElem.background};
  }
`

export const ChannelLogo = styled.div`
  flex: 0 0 180px;
  background-color: ${(props) => props.theme.colors.broadcast.logoBackground};
  height: 114px;
  position: relative;
  z-index: 5;
  img {
    max-width: 135px;
    max-height: 80px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    object-fit: contain;
  }
`

export const ChannelEvent = styled.div`
  padding: 16px;
  position: relative;
  overflow: hidden;
  z-index: 5;
`

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  max-width: 290px;
  font-weight: 500;
  font-size: 20px;
  text-align: left;
`

export const Name = styled.div`
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.broadcast.title};
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const Time = styled.div`
  font-size: 18px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${(props) => props.theme.colors.broadcast.text};
`
